import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import CommonService from '../services/common.service';

export class ElementsComponent {
    constructor() {
        this.componentName = "elementsComponent";
        this.template = `
            <h3>Elements Results</h3>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Month</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody id="data_row">
        <tr class="table-default">
          <td scope="row">January 2020</td>
          <td>100</td>
        </tr>
      </tbody>
    </table>
        `;
        
        this.rowTemplate = `
        <tr class="table-default">
          <td scope="row">{MonthYear}</td>
          <td>{Count}</td>
        </tr>
        `;

        this.cache = undefined;
        this.cacheExpiration = undefined;
    }
	
	render() {
        _svc.common.renderResults("Elements", _cmp.elements);
	}
    
    postBackSuccess(data) {
        _svc.common.populateDataRows(data, _cmp.elements.rowTemplate, _cmp.elements.componentName, _cmp.elements.template);
        _svc.common.handleCache(_cmp.elements);
	}
	
	postBackFailed(){
		_svc.util.clear("#"+_cmp.elements.componentName);
	}
	
	cacheExpired() {
		if (this.cacheExpiration == undefined) return true;
		if (this.cache == undefined) return true;
		return this.cacheExpiration < _svc.util.now();
	}
};
setTimeout(() => {
    _cmp.elements = new ElementsComponent();    
}, 1);
